import { SkeletonLoader } from '@toggle/design-system';
import React from 'react';

import styles from './LoadingCell.module.scss';

export const LoadingCell = () => {
  return (
    <div className={styles.root}>
      <div className={styles.leftWrapper}>
        <SkeletonLoader
          areas={[
            { styles: { width: '32px', height: '32px', borderRadius: '40px' } },
          ]}
        />
        <SkeletonLoader
          areas={[
            { styles: { width: '114px', height: '24px', borderRadius: '8px' } },
          ]}
        />
      </div>
      <div className={styles.rightWrapper}>
        <SkeletonLoader
          areas={[
            { styles: { width: '48px', height: '24px', borderRadius: '8px' } },
          ]}
        />
      </div>
    </div>
  );
};
